var TimerService = {
    queue: [],
    timer: null,
    register: function (fn) {
        this.queue.push(fn);
        if (!this.timer) {
            this.startTimer();
        }
    },
    unregister: function (fn) {
        this.queue = this.queue.filter(function (f) { return f !== fn; });
        if (!this.queue.length && this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    },
    startTimer: function () {
        var _this = this;
        this.timer = setInterval(function () {
            _this.queue.forEach(function (cb) { return cb(); });
        }, 1000);
    },
};
export default TimerService;
